import React, { useContext } from "react";
import Header from "../../components/Header";
import AccoutSetting from "../../components/AccountSettings";
import { BsFileImageFill } from "react-icons/bs";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { ArrowLeftIcon } from "@radix-ui/react-icons";
import { bgcolors } from "../../constants/BackgroundColors";
import { Link } from "react-router-dom";
import { CUSTOMIZATIONS } from "../../constants/settingsStrings.js";
import Bottombar from "../../components/Bottombar";
import Topbar from "../../components/Topbar";
import { ThemeContext } from "../../ThemeContext/ThemeContext.js";

function DisplayCustomization() {
  const { theme, toggleTheme } = useContext(ThemeContext);
  return (
    <div>
      <div className="relative w-screen overflow-hidden  h-screen dark:bg-black dark:text-white">
        <Topbar />
        <div className="md:block hidden">
          <Header />
        </div>

        <div className="sm:flex bg-white sm:items-center  dark:bg-black sm:space-x-10 sm:px-10 sm:mt-5 sm:justify-center">
          <div className="md:block hidden">
            <AccoutSetting active={CUSTOMIZATIONS} />
          </div>
          <div className=" ">
            <div className=" sm:shadow-md z-auto  rounded-[25px]  overflow-y-auto  sm:w-[900px]  h-[700px] sm:h-[500px]  sm:left-[390px] ">
              <h3 className=" grid md:block hidden sm:ml-[300px] place-content-center font-sans font-bold ">
                Display and Customization
              </h3>

              <div className="sm:flex sm:space-x-[70px]">
                <div className=" sm:ml-3 hidden md:block">
                  <h3 className="font-bold font-serif m-2 ">Display</h3>
                  <div className="border items-center px-4 w-[350px] bg-[#D9D9D9] dark:bg-[#fff] dark:text-[#000] rounded-[25px] relative ">
                    <div className="flex justify-between items-center m-3">
                      <h3 className="text-[15px] ">Night Mode</h3>
                      <input
                        className="mr-2 mt-[0.3rem] h-3.5 w-8  appearance-none rounded-[0.4375rem] bg-[#545454] before:pointer-events-none before:absolute before:h-3.5 before:w-3.5 before:rounded-full before:bg-transparent before:content-[''] after:absolute after:z-[2] after:-mt-[0.1875rem] after:h-5 after:w-5 after:rounded-full after:border-none after:bg-neutral-100 after:shadow-[0_0px_3px_0_rgb(0_0_0_/_7%),_0_2px_2px_0_rgb(0_0_0_/_4%)] after:transition-[background-color_0.2s,transform_0.2s] after:content-[''] checked:bg-primary checked:after:absolute checked:after:z-[2] checked:after:-mt-[3px] checked:after:ml-[1.0625rem] checked:after:h-5 checked:after:w-5 checked:after:rounded-full checked:after:border-none checked:after:bg-primary checked:after:shadow-[0_3px_1px_-2px_rgba(0,0,0,0.2),_0_2px_2px_0_rgba(0,0,0,0.14),_0_1px_5px_0_rgba(0,0,0,0.12)] checked:after:transition-[background-color_0.2s,transform_0.2s] checked:after:content-[''] hover:cursor-pointer focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[3px_-1px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-5 focus:after:w-5 focus:after:rounded-full focus:after:content-[''] checked:focus:border-primary checked:focus:bg-primary checked:focus:before:ml-[1.0625rem] checked:focus:before:scale-100 checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] dark:bg-neutral-600 dark:after:bg-neutral-400 dark:checked:bg-primary dark:checked:after:bg-primary dark:focus:before:shadow-[3px_-1px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca]"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckDefault"
                        onChange={toggleTheme}
                        checked={theme === "dark"}
                      />
                    </div>
                    {/* <div className="border border-[#878787]"></div>
                    <div className="flex justify-between items-center m-3">
                      <h3 className="text-[15px] ">
                        Light Mode
                      </h3>
                      <input
                        className="mr-2 mt-[0.3rem] h-3.5 w-8 appearance-none rounded-[0.4375rem] bg-[#545454] before:pointer-events-none before:absolute before:h-3.5 before:w-3.5 before:rounded-full before:bg-transparent before:content-[''] after:absolute after:z-[2] after:-mt-[0.1875rem] after:h-5 after:w-5 after:rounded-full after:border-none after:bg-[#BE2117] after:shadow-[0_0px_3px_0_rgb(0_0_0_/_7%),_0_2px_2px_0_rgb(0_0_0_/_4%)] after:transition-[background-color_0.2s,transform_0.2s] after:content-[''] checked:bg-primary checked:after:absolute checked:after:z-[2] checked:after:-mt-[3px] checked:after:ml-[1.0625rem] checked:after:h-5 checked:after:w-5 checked:after:rounded-full checked:after:border-none checked:after:bg-primary checked:after:shadow-[0_3px_1px_-2px_rgba(0,0,0,0.2),_0_2px_2px_0_rgba(0,0,0,0.14),_0_1px_5px_0_rgba(0,0,0,0.12)] checked:after:transition-[background-color_0.2s,transform_0.2s] checked:after:content-[''] hover:cursor-pointer focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[3px_-1px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-5 focus:after:w-5 focus:after:rounded-full focus:after:content-[''] checked:focus:border-primary checked:focus:bg-primary checked:focus:before:ml-[1.0625rem] checked:focus:before:scale-100 checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] dark:bg-neutral-600 dark:after:bg-neutral-400 dark:checked:bg-primary dark:checked:after:bg-primary dark:focus:before:shadow-[3px_-1px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca]"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckDefault"
                      />
                    </div> */}
                  </div>

                  <h3 className="text-[15px] font-bold mt-1 ">
                    Customization{" "}
                  </h3>
                  <div className="border items-center  p-4 w-[350px] h-[62px] mt-1 bg-[#D9D9D9] dark:bg-[#fff] dark:text-[#000] rounded-[15px]">
                    <Link
                      to="/settings/customs"
                      className="flex justify-between items-center "
                    >
                      <div>
                        <h3 className="text-[15px] ">Customization Model </h3>
                      </div>

                      <MdOutlineKeyboardArrowRight size={17} color="#000000" />
                    </Link>
                  </div>
                  <h3 className="font-bold text-[20px] mt-3 dark:text-white ">
                    Gender
                  </h3>
                  <div className="w-full max-w-xs">
                    <select className="block w-[350px] h-[27px] py-1  text-black bg-[#D9D9D9] dark:bg-[#fff]  px-7  rounded-[15px] shadow-md focus:outline-none focus:shadow-outline-blue mr-2">
                      <option value="defaul"> Male</option>
                      <option value="option1">Male </option>
                      <option value="option2">Female</option>
                    </select>
                  </div>

                  <div className="flex m-1">
                    {bgcolors.map(({ id, color }) => (
                      <div
                        key={id}
                        className={`border flex rounded-full   w-[20px] m-1 h-[20px] ${color}`}
                      ></div>
                    ))}
                  </div>

                  <div className="flex m-1">
                    {bgcolors.map(({ id, color }) => (
                      <div
                        key={id}
                        className={`border flex rounded-full w-[20px] m-1 h-[20px] ${color}`}
                      ></div>
                    ))}
                  </div>
                  <div className=" flex">
                    <h3 className="text-[10px] font-bold dark:text-black">
                      OutFit Collections{" "}
                    </h3>
                    <button className=" justify-center items-center ml-[150px] bg-[#BE2117] w-[100px] h-[30px] text-white rounded-[25px] flex p-2 text-[10px]">
                      clothes{" "}
                      <span className="ml-2">
                        <img
                          src={require("./../../assets/img/cone.png")}
                          className="w-[10px] h-[10px]"
                        />
                      </span>
                    </button>
                  </div>
                  <div className="flex  space-x-3 ">
                    <div className="bg-[#D9D9D9] mt-1 border  rounded-[25px] w-[100px] h-[128px] m-2"></div>
                    <div className="bg-[#D9D9D9] mt-1 border   rounded-[25px] w-[100px] h-[128px] m-2"></div>
                    <div className="bg-[#D9D9D9] mt-1 border   rounded-[25px] w-[100px] h-[128px] m-2"></div>
                  </div>
                  <div className="">
                    <button className=" justify-center items-center ml-[235px] bg-[#BE2117] w-[100px] h-[30px] text-white rounded-[25px] flex p-2 text-[10px]">
                      Shoes{" "}
                      <span className="ml-2">
                        <img
                          src={require("./../../assets/img/shoe.png")}
                          className="w-[10px] h-[10px]"
                        />
                      </span>
                    </button>

                    <div className="flex  space-x-3 ">
                      <div className="bg-[#D9D9D9] mt-1 border  rounded-[25px] w-[100px] h-[128px] m-2"></div>
                      <div className="bg-[#D9D9D9] mt-1 border   rounded-[25px] w-[100px] h-[128px] m-2"></div>
                      <div className="bg-[#D9D9D9] mt-1 border   rounded-[25px] w-[100px] h-[128px] m-2"></div>
                    </div>
                  </div>
                </div>

                <div className=" ml-8 ">
                  {" "}
                  {/* <h3 className="font-bold  font-sans text-[20px] flex space-x-10 items-center dark:text-black">
                    <span className=" mr-[60px] sm:hidden dark:text-white">
                      <Link to="/settings/customise">
                        {" "}
                        <AiOutlineClose size={20}  />
                      </Link>
                    </span>{" "}
                    Model Customization
                  </h3> */}
                  <div className="flex  space-x-[30px] px-3">
                    <Link to="/settings">
                      {" "}
                      <ArrowLeftIcon
                        color="gray"
                        className="w-10 h-10 sm:hidden"
                      />
                    </Link>

                    <h3 className="grid  place-content-center font-bold text-[20px] dark:text-white ">
                      Model Customization
                    </h3>
                  </div>
                  <div className=" ">
                    <div className=" bg-image-container relative  bg-cover  bg-center sm:w-[330px] sm:h-[398.83px]  w-[358px] right-4 h-full rounded-[25px] grid place-content-center bg-hero-pattern">
                      <img
                        src={require("../../assets/img/saly.png")}
                        alt=""
                        className=" sm:w-[285.04px] sm:h-[397.59px] w-[185.04px] h-[297.59px]"
                      />

                      <div className="absolute space-x-[230px] p-3 flex fixed  bottom-0 mt-[100px] items-center">
                        <BsFileImageFill color="white" />
                        <button className="text-white bg-[#6A6A6A] rounded-[25px] px-2 ">
                          save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="border sm:hidden items-center  p-4 w-[90%]  sm:mt-3 mt-2 ml-4 bg-[#D9D9D9] dark:bg-[#fff] dark:text-[#000] rounded-[15px]">
                    <Link
                      to="/settings/customise"
                      className="flex justify-between items-center "
                    >
                      <div>
                        <h3 className="text-[15px] ">Display Settings</h3>
                      </div>

                      <MdOutlineKeyboardArrowRight size={17} color="#000000" />
                    </Link>
                  </div>

                <div className="sm:hidden">
                  <h3 className="font-bold text-[20px] sm:mt-3 mt-2 ml-4 dark:text-white">
                    Gender
                  </h3>
                  <div className="w-350px] max-w-xs ml-3 ">
                    <select className="block   w-[140px] bg-[#D9D9D9] px-3 h-[60px] sm:py-1 text-black dark:text-white py-5 pr-5  dark:bg-[#D9D9D9] rounded-[25px] shadow-md focus:outline-none focus:shadow-outline-blue  ">
                      <option
                        disabled
                        selected
                        value=" default"
                        className="w-10"
                      >
                        Male
                      </option>
                      <option value="option1" className="w-10">
                        Male{" "}
                      </option>
                      <option value="option2" className="w-10">
                        Female
                      </option>
                    </select>
                  </div>
                  <h3 className="font-bold sm:text-[20px] text-[15px] m-2 sm:m-4 dark:text-white">
                    {" "}
                    Skin Colour{" "}
                  </h3>
                  <div className="flex m-1">
                    {bgcolors.map(({ id, color }) => (
                      <div
                        key={id}
                        className={`border flex rounded-full ml-2  w-[43px] m-1 px-2 h-[43px] ${color}`}
                      ></div>
                    ))}
                  </div>

                  <button className=" justify-center items-center ml-[235px] bg-[#BE2117] w-[150px] h-[50px] text-white rounded-[25px] flex p-2 text-[20px]">
                    clothes{" "}
                    <span className="ml-2">
                      <img
                        src={require("./../../assets/img/cone.png")}
                        className="w-[20px] h-[20px]"
                      />
                    </span>
                  </button>
                  <h3 className="font-sans text-[20px] font-bold ml-3 dark:text-white   ">
                    OutFits Collections
                  </h3>
                  <div className="flex  space-x-3 ">
                    <div className="bg-[#D9D9D9] mt-1 border  rounded-[25px] w-[150px] h-[128px] m-2"></div>
                    <div className="bg-[#D9D9D9] mt-1 border   rounded-[25px] w-[150px] h-[128px] m-2"></div>
                    <div className="bg-[#D9D9D9] mt-1 border   rounded-[25px] w-[150px] h-[128px] m-2"></div>
                  </div>
                  <div className="">
                    <button className=" justify-center items-center ml-[235px] bg-[#BE2117] w-[150px] h-[50px] text-white rounded-[25px] flex p-2 text-[20px]">
                      Shoes{" "}
                      <span className="ml-2">
                        <img
                          src={require("./../../assets/img/shoe.png")}
                          className="w-[20px] h-[20px]"
                        />
                      </span>
                    </button>

                    <div className="flex  space-x-3 ">
                      <div className="bg-[#D9D9D9] mt-1 border  rounded-[25px] w-[150px] h-[128px] m-2"></div>
                      <div className="bg-[#D9D9D9] mt-1 border   rounded-[25px] w-[150px] h-[128px] m-2"></div>
                      <div className="bg-[#D9D9D9] mt-1 border   rounded-[25px] w-[150px] h-[128px] m-2"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Bottombar activeBar={'settings'} />
      </div>
    </div>
  );
}

export default DisplayCustomization;
